import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { exhRegUrl, userManualDownloadUrl, disclaimer } from '../utils/constants';
import Modal from "react-modal";
import StepHeader from '../screens/registration/stepHeader'
import ExhibitorTopMenu from "../common_components/exhibitor_module_topmenu";


Modal.setAppElement("#root");


// {head,subHeader}
const AgentHeader = () => {
    const navigate = useNavigate();

    const history = useNavigate();
    const [isLoading, setLoader] = useState(false);
    const [agentCode, setAgentCode] = useState("")
    const marqueeRef = useRef(null);
    const [showProfile, setShowProfile] = useState(false);

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js',
        //   'js/azia.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }

    useEffect(() => {
        loadScripts();
        // console.log("sessionStorage.getItem(sessionExhibitorDrawerData)------->", sessionStorage.getItem(sessionExhibitorDrawerData))
        var agentCode = sessionStorage.getItem('IsAgentDirectLogin') != null && sessionStorage.getItem('IsAgentDirectLogin') == "false" ?
            JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['AgentCode'] != null &&
            JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['AgentCode'] :
            JSON.parse(sessionStorage.getItem('loginDataSS'))['AgentCode'] != null &&
            JSON.parse(sessionStorage.getItem('loginDataSS'))['AgentCode']

        setAgentCode(agentCode)

    }, []);


    const openPdf = () => {
        var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
        window.open(URL, null);
    }

    const address = sessionStorage.getItem('ExhibitionAddressSS')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    const profileRef = useRef(null);
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                profileRef.current &&
                !profileRef.current.contains(event.target)
            ) {
                setShowProfile(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <>

                {isMobileMenuOpen && (
                    <div
                        className="mobile-menu-overlay exhibitor-mobile-overlay"
                        onClick={closeMobileMenu}
                    ></div>
                )}


                <div
                    className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
                        }`}
                >
                    <div className="mobile-menu-header exhibitor-menu-header">
                        <button
                            onClick={closeMobileMenu}
                            className="exhibitor-menu-close-btn text-white"
                        >
                            ×
                        </button>
                        <div className="user-info exhibitor-user-info">
                            <h5 className=" text-white mb-0">Welcome,</h5>
                            <h4 className="text-uppercase fw-semibold text-white fw-bold">
                                {sessionStorage.getItem("firstNameSS")}
                            </h4>
                        </div>
                    </div>
                    <div className="mobile-menu-content exhibitor-menu-content">
                        <div className="menu-section exhibitor-details-section">
                            <h6 className="exhibitor-section-title">Exhibition Details</h6>
                            <p className="exhibitor-detail-text mb-2">
                                {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
                                {sessionStorage.getItem("ExhibitionToDateSS")} <br />
                                {address}
                            </p>
                        </div>

                        <div className="menu-section exhibitor-links-section">
                            <h6 className="exhibitor-section-title gap-1">Quick Links</h6>
                            <a
                                href={corporateLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="exhibitor-menu-link mb-2 mobi"
                                onClick={closeMobileMenu}
                            >
                                For new corporate site please <span className="text-primary ms-1"> Click here</span>
                            </a>

                        </div>

                        <div className="menu-section exhibitor-account-section">
                            {/* <h6 className="exhibitor-section-title">Exhibitor Account</h6> */}
                            <Link
                                to={"/Change_Password"}
                                className="exhibitor-menu-link mb-2"
                                onClick={closeMobileMenu}
                            >
                                <i
                                    className="fa fa-cog exhibitor-menu-icon "
                                    aria-hidden="true"
                                ></i>
                                Change Password
                            </Link>
                            <button
                                onClick={() => {
                                    closeMobileMenu();
                                    onLogoutClick();
                                }}
                                className="exhibitor-menu-link exhibitor-logout-btn"
                            >
                                <i
                                    className="fa fa-sign-out exhibitor-menu-icon"
                                    aria-hidden="true"
                                ></i>
                                Sign out
                            </button>
                        </div>
                    </div>
                </div>
                {/* app-Header */}
                {/* <div className="app-header header sticky app-heder-with-logo">
                    <div className="container-fluid main-container">
                        <div className="d-flex" style={{ marginTop: '-1rem' }}>
                            <h5 className="exbheader">
                                {" "}
                                {sessionStorage.getItem('ExhibitionFromDateSS')} - {sessionStorage.getItem('ExhibitionToDateSS')} <br />
                                {sessionStorage.getItem('ExhibitionAddressSS')}{" "}<br></br>
                                <span className='mt-1'> For new corporate site please   <a href='https://corporate.india-itme.com' target='blank' className='header-login-a'>click here</a></span>
                            </h5>
                            <div className="right-logo-logo">
                                <img src="images/itme-right-logo.png" style={{ width: 70 }} />
                            </div>
                            <p />
                            <a className="logo-horizontal" href="index.html">
                                <img
                                    src="images/itme-right-logo.png"
                                    className="header-brand-img light-logo1"
                                    alt="logo"
                                    style={{ width: '100%' }}
                                />
                            </a>
                            <div className="d-flex order-lg-2 ms-auto header-right-icons">
                                <button
                                    className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent-4"
                                    aria-controls="navbarSupportedContent-4"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-icon fe fe-more-vertical" />
                                </button>
                                <div className="navbar navbar-collapse responsive-navbar p-0">
                                    <div
                                        className="collapse navbar-collapse"
                                        id="navbarSupportedContent-4"
                                    >
                                        <div className="d-flex order-lg-2">
                                            <div className="dropdown d-lg-none d-flex">
                                                <a
                                                    href="javascript:void(0)"
                                                    className="nav-link icon"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <i className="fe fe-search" />
                                                </a>
                                                <div className="dropdown-menu header-search dropdown-menu-start">
                                                    <div className="input-group w-100 p-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search...."
                                                        />
                                                        <div className="input-group-text btn btn-primary">
                                                            <i className="fa fa-search" aria-hidden="true" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex country">
                                                <a className="nav-link icon text-center">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="marquee-text">
                            <marquee
                                behavior="scroll"
                                direction="left"
                                scrollamount="5"
                                ref={marqueeRef}
                                onMouseOver={() => marqueeRef.current?.stop()}
                                onMouseOut={() => marqueeRef.current?.start()}
                            >
                                <b>Disclaimer and Ownership:</b> {disclaimer}
                            </marquee>
                        </div>
                    </div>
                    <div className="user-sle" style={{ marginTop: '-1rem' }}>
                        <div className="user-sle2 mt-1">
                            <i className="fa fa-user-o" aria-hidden="true" />{" "}
                            {
                                sessionStorage.getItem('IsAgentDirectLogin') != null && sessionStorage.getItem('IsAgentDirectLogin') == "false" ?
                                    <span style={{ textTransform: "uppercase" }}>
                                        {JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['FirstName'] != null &&
                                            JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['FirstName']}</span> :
                                    <span style={{ textTransform: "uppercase" }}>
                                        {JSON.parse(sessionStorage.getItem('loginDataSS'))['FirstName'] != null &&
                                            JSON.parse(sessionStorage.getItem('loginDataSS'))['FirstName']}</span>
                            }

                        </div>
                        <div className="mt-1">
                            <a href={`/#/${sessionStorage.getItem("sessionExhibitionCode")}-${agentCode}-Exh`} className='change-pas' target="_blank"><i class="fa fa-share-alt" ></i> Share Link to Exhibitor</a>
                        </div>
                    </div>
                </div> */}

                <div className="app-header header sticky app-heder-with-logo pt-0">
                    <div className="container-fluid main-container">
                        <div className="d-flex align-items-center justify-content-between">
                            {/* LOGO */}
                            <div className="side-header d-flex align-items-center">
                                <img
                                    src={sessionStorage.getItem("ExhibitionLogoSS")}
                                    alt="logo"
                                    style={{ width: '45px', margin: '0 auto' }}
                                />
                            </div>

                            {/* EXHIBITION INFO */}
                            <h5 className="exbheader text-white d-none d-md-block">
                                {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
                                {sessionStorage.getItem("ExhibitionToDateSS")} <br />
                                {sessionStorage.getItem("ExhibitionAddressSS")}
                            </h5>

                            {/* PROFILE ICON */}
                            <div className="position-relative" ref={profileRef}>
                                <i
                                    className="fa fa-user-circle fa-2x text-white"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowProfile(!showProfile)}
                                ></i>

                                {/* PROFILE DROPDOWN */}
                                {showProfile && (
                                    <div className="profile-dropdown shadow">
                                        <div className="profile-header">
                                            <i className="fa fa-user-o"></i>{" "}
                                            <strong>
                                                {sessionStorage.getItem("firstNameSS")}
                                            </strong>
                                        </div>

                                        <div className="profile-body">
                                            <p className="mb-0 pt-0">
                                                <div className="menu-section exhibitor-links-section">
                                                    <h6 className="exhibitor-section-title gap-1">Quick Links</h6>
                                                    <a
                                                        href={corporateLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="exhibitor-menu-link mb-2 mobi"
                                                        onClick={closeMobileMenu}
                                                    >
                                                        For new corporate site please <span className="text-primary ms-1"> Click here</span>
                                                    </a>

                                                </div> <a href={`/#/${sessionStorage.getItem("sessionExhibitionCode")}-${agentCode}-Exh`} className='change-pas' target="_blank"><i class="fa fa-share-alt" ></i> Share Link to Exhibitor</a>
                                            </p>

                                            {/* <p>
                                                      <i className="fa fa fa-list exh-header" aria-hidden="true" /> <span>
                                                        {sessionStorage.getItem('sessionHeaderData') != null &&
                                                          JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['StallTypeName']}
                                                      </span>
                                                    </p>
                                                    <p>
                                
                                                      <i className="fa fa-th exh-header" aria-hidden="true" />{" "}
                                                      <span>
                                                        {sessionStorage.getItem('sessionHeaderData') != null &&
                                                          JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['StallArea']}(m<sup>2</sup>)
                                                      </span>
                                                    </p> */}

                                        </div>

                                        <div className="profile-footer">
                                            <Link
                                                to="/Change_Password"
                                                className="dropdown-item bg-light px-2"
                                                onClick={() => setShowProfile(false)}
                                            >
                                                <i className="fa fa-cog me-1"></i> Change Password
                                            </Link>

                                            <button
                                                className="logout-btn dropdown-item px-2 bg-danger text-white"
                                                onClick={onLogoutClick}
                                            >
                                                <i className="fa fa-sign-out me-1"></i> Logout
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* DISCLAIMER */}
                        <marquee
                            style={{ fontSize: "15px", color: "#fff" }}
                            behavior="scroll"
                            direction="left"
                            scrollamount="5"
                            ref={marqueeRef}
                            onMouseOver={() => marqueeRef.current?.stop()}
                            onMouseOut={() => marqueeRef.current?.start()}
                        >
                            <b>Disclaimer:</b> {disclaimer}
                        </marquee>
                    </div>

                    <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
                        <button
                            onClick={toggleMobileMenu}
                            className="exhibitor-menu-toggle-btn"
                        >
                            <span className="exhibitor-menu-toggle-bar"></span>
                            <span className="exhibitor-menu-toggle-bar"></span>
                            <span className="exhibitor-menu-toggle-bar"></span>
                        </button>
                    </div>

                </div>


                {/* /app-Header */}
            </>

        </>
    );
}
export default AgentHeader;

